import React from 'react';
import AppPhone, { HomeScreen, SharedAccessScreen, BuildingSwitcherScreen } from './AppPhone';
import { appScreensFor, BUILDINGS } from '../../data/appScreens';

const plain = (title) => title.replace(/\s*\p{Extended_Pictographic}️?/gu, '');

/*
 * The app mockup for a landing page section. `kind`:
 * - home: the home feed with the page's routines
 * - setup: step 1 of How It Works (shared access on the roommates page, otherwise the home feed)
 * - notification: the home feed with the buzz-in push for the page's lead routine
 * - switcher: the building switcher sheet (Business page)
 */
const LandingPhone = ({ channel, kind = 'home', className = '' }) => {
  const page = appScreensFor(channel);
  const lead = plain(page.cards[0].title);
  let label = `Lowkey app home screen with the ${lead} routine active`;
  const callout = kind === 'setup' || kind === 'notification';
  let screen = (uid) => <HomeScreen cards={page.cards} building={page.building} callout={callout} uid={uid} />;

  if (kind === 'setup' && page.users) {
    label = 'Lowkey app screen for managing roommates who share access to the buzzer';
    screen = () => <SharedAccessScreen users={page.users} />;
  } else if (kind === 'notification') {
    label = `Lowkey push notification: access granted with ${lead}`;
    screen = (uid) => (
      <HomeScreen
        cards={page.cards}
        building={page.building}
        notification={page.notification}
        callout={callout}
        uid={uid}
      />
    );
  } else if (kind === 'switcher') {
    label = 'Lowkey app building switcher listing multiple buildings';
    screen = (uid) => <BuildingSwitcherScreen buildings={BUILDINGS} cards={page.cards} uid={uid} />;
  }

  return (
    <AppPhone label={label} className={`drop-shadow-[0_10px_30px_rgba(65,225,176,0.18)] ${className}`}>
      {screen}
    </AppPhone>
  );
};

export default LandingPhone;
